export default (props, vars) => props?.['name'] === 'star-green';
